// In this folder, common variables can be accessed and edited in a single place.
export default {
  data() {
    return {
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'reference',
      // Where data is fetched from
      endpoint: 'reference',
      // The object key from the response object
      responseData: {
        multiple: 'references',
        single: 'reference',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'reference',
    };
  },
};
